export class StockProjectNotFoundError extends Error {
  constructor(projectId: number) {
    super(`Project ${projectId} not found`);
    this.name = 'StockProjectNotFoundError';
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
